/**
 * Export the object and properties here.
 *
 * This will allow us to call the rest opbject
 * methods from the client code as:
 *
 * rest.foo(params);
 *
 * We do not need to call this in front.js.
 *
 * @type {{foo: foo, bar: bar}}
 */

/**
 * Require jQuery.
 */
var $ = require('jquery');

/**
 * Request json from an API endpoint.
 *
 * A callback from the calling module needs to be passed here
 * so we know what to do with the data on a successful
 * response. You will pass the full object.function as the callback.
 * For example: rest.getJson('uri', myModule.foo);
 *
 * A spinner can be added while waiting for the request using
 * ajaxStart and ajaxStop properties.
 *
 * @param path string URL of the rest endpoint.
 * @param callback the callback function after ajax success.
 *
 */
var getJson = function(path, callback) {

    $.ajax({
        type: 'GET',
        url: path,
        dataType: "json",
        ajaxStart: function(elem) {
            console.log(elem);
          elem.html('Loading...');
        },
        ajaxStop: function(elem) {
            var text = elem.innerHTML();
            elem.html(text);
        },
        success: function(data) {
            // Execute a callback function if one was passed.
            if (typeof callback === 'function') {
                callback(data);
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('Ajax request error ' + textStatus + ' ' + errorThrown);
            return false;
        },
        statusCode: {
            404: function() {
                console.error('Ajax request error 404');
                return false;
            }
        }
    });
};

/**
 * Set an Ajax utility. Only Json data for now.
 * A spinner can be added while waiting for the request using
 * ajaxStart and ajaxStop properties.
 */
var postJson = function(path, data, callback) {

    $.ajax({
        type: 'POST',
        url: path,
        beforeSend: function ( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
        },
        // Will be available to php as $_POST['json'].
        data: { "json" : data},
        dataType: "json",
        success: function(data) {
            // Execute a callback function if one was passed.
            if (typeof callback === 'function') {
                callback(data);
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('Ajax request error ' + textStatus + ' ' + errorThrown);
        },
        statusCode: {
            404: function() {
                alert("Ajax request error: 404");
            }
        }
    });

    return false;

};

/**
 * Export the methods.
 *
 */
module.exports = {
    getJson: getJson,
    postJson: postJson
};



